import { render, staticRenderFns } from "./TagLetterIcon.vue?vue&type=template&id=1ec6a458&scoped=true&"
import script from "./TagLetterIcon.vue?vue&type=script&lang=ts&"
export * from "./TagLetterIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TagLetterIcon.vue?vue&type=style&index=0&id=1ec6a458&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec6a458",
  null
  
)

export default component.exports